import { render } from "./FileComments.vue?vue&type=template&id=e7be2944"
import script from "./FileComments.vue?vue&type=script&lang=js"
export * from "./FileComments.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/mobysuite-docs-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__